module.exports = __webpack_public_path__ + "assets/TriangleBySides.2be84864b01680a8d6fdbd1cdecdc524.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TriangleBySides.gmt
// module id = 1029
// module chunks = 0